// Footer menus: accordion on mobile (CSS hides collapsed lists only below md)
document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll(".pk-footer .footer-menu-toggle").forEach((toggle) => {
		toggle.addEventListener("click", () => {
			const isOpen = toggle.getAttribute("aria-expanded") === "true";
			toggle.setAttribute("aria-expanded", String(!isOpen));
		});
	});
});
